import { useEffect } from "react";

const PmisupportVdeo = () => {
//   useEffect(() => {
//     window.parent.postMessage(
//       { action: "redirectTo", label: "points-history" },
//       "*"
//     );
//   }, []);

  return (
    <iframe
      src="https://pmi-salesforce.videomarketingplatform.co/v.ihtml/player.html?token=f1d0a48bd0a379bf83769b379f1b0b20&source=embed&photo%5fid=118727775&endOn=thumbnail"
      width="100%"
      height="600"
      frameBorder="0"
      allowFullScreen
    ></iframe>
  );
};

export default PmisupportVdeo;
